import { useState, type FormEvent } from 'react';
import { Link as RouterLink } from 'react-router';
import { Alert, Box, Button, Link, Stack, TextField } from '@mui/material';
import { api, ApiError } from '../../api/client';
import { t } from '../../i18n/sq';
import { AuthShell } from './AuthShell';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t.common.unexpectedError);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell title={t.auth.forgotTitle} subtitle={sent ? undefined : t.auth.forgotSubtitle}>
      <Box component="form" onSubmit={submit}>
        <Stack spacing={2.5}>
          {error && <Alert severity="error">{error}</Alert>}
          {sent ? (
            <Alert severity="success">{t.auth.forgotSent}</Alert>
          ) : (
            <>
              <TextField
                label={t.auth.email}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <Button type="submit" variant="contained" size="large" loading={busy}>
                {t.auth.sendLink}
              </Button>
            </>
          )}
          <Link component={RouterLink} to="/hyr" sx={{ textAlign: 'center' }}>
            {t.auth.backToLogin}
          </Link>
        </Stack>
      </Box>
    </AuthShell>
  );
}
